import * as React from "react";

import { cn } from "@/lib/utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      className={cn(
        "min-h-28 w-full resize-y rounded-md border border-input bg-card px-3 py-2.5 text-base outline-none transition-[border-color,box-shadow,background-color,opacity] duration-150 ease-out placeholder:text-muted-foreground/70 focus-visible:border-primary focus-visible:shadow-[var(--field-focus-shadow)] disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-50 aria-invalid:border-destructive aria-invalid:shadow-[var(--field-focus-shadow)]",
        className,
      )}
      data-slot="textarea"
      {...props}
    />
  );
}

export { Textarea };
